export default "__VITE_ASSET__CmjSKCWL__"